
export default function Installation() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const steps = [
    {
      number: '01',
      title: 'Free Consultation',
      description: 'We assess your home and recommend the best security solution for your needs',
      icon: 'ri-chat-check-line'
    },
    {
      number: '02',
      title: 'Professional Installation',
      description: 'Certified technicians install your system in 3-4 hours with minimal disruption',
      icon: 'ri-tools-line'
    },
    {
      number: '03',
      title: 'System Training',
      description: 'Complete walkthrough of your system and mobile app to ensure you are comfortable',
      icon: 'ri-graduation-cap-line'
    },
    {
      number: '04',
      title: 'Ongoing Support',
      description: '24/7 customer support and monitoring to keep your home protected',
      icon: 'ri-customer-service-2-line'
    }
  ];

  return (
    <section id="installation" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center mb-24">
          <div className="relative">
            <div className="absolute -top-6 -left-6 w-24 h-24 bg-teal-100 rounded-3xl -z-10"></div>
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-gray-100 rounded-3xl -z-10"></div>
            <div className="w-full h-[500px] rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/65519f8f1c3500688802a50a258660ab.jpg" 
                alt="Professional Installation"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute top-8 left-8 bg-white/95 backdrop-blur-sm px-4 py-2 rounded-full text-xs font-semibold text-gray-900">
              PROFESSIONAL SERVICE
            </div>
          </div>

          <div>
            <h2 className="text-5xl md:text-6xl font-bold text-gray-900 leading-tight mb-6" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              EXPERT<br />INSTALLATION<br />GUARANTEED
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Our certified technicians will install your complete security system in 3-4 hours. We handle everything from sensor placement to mobile app setup, ensuring your home is protected before we leave.
            </p>
            <div className="space-y-4 mb-8">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-teal-600 rounded-full flex-shrink-0">
                  <i className="ri-check-line text-xl text-white"></i>
                </div>
                <span className="text-gray-700 font-medium">Same-day installation available</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-teal-600 rounded-full flex-shrink-0">
                  <i className="ri-check-line text-xl text-white"></i>
                </div>
                <span className="text-gray-700 font-medium">Complete system testing included</span>
              </div>
            </div>
            <button 
              onClick={() => scrollToSection('contact')}
              className="whitespace-nowrap px-8 py-4 bg-gray-900 text-white rounded-full text-base font-semibold hover:bg-gray-800 transition-all cursor-pointer"
            >
              Schedule Installation →
            </button>
          </div>
        </div>

        <div className="bg-gradient-to-br from-teal-600 to-teal-700 rounded-3xl p-12 md:p-16">
          <div className="text-center mb-12">
            <h3 className="text-3xl md:text-4xl font-bold text-white mb-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              Our Installation Process
            </h3>
            <p className="text-teal-100 text-lg">
              Simple, professional, and hassle-free
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-2xl mx-auto mb-4">
                  <i className={`${step.icon} text-3xl text-white`}></i>
                </div>
                <div className="text-5xl font-bold text-white/30 mb-3">{step.number}</div>
                <h4 className="text-xl font-bold text-white mb-3">{step.title}</h4>
                <p className="text-teal-100 text-sm leading-relaxed">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
